import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, fade } from '@material-ui/core/styles';
import {
  fasciaScadenza,
  giorniAllaScadenza,
  statoScadenza,
} from './scadenzaDocumento';

// Surfaces with a text colour paired to each, never a coloured text on white:
// the theme's yellow reads at 1.1:1 as text. The two warning steps keep the
// same brown on top and differ in the surface, amber within 15 days and yellow
// within 30; the expiry day takes the amber, as the app's badge does. Expired
// is the error red, tinted the way the section tints its other pills.
const useStyles = makeStyles((theme) => ({
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    padding: theme.spacing(0.25, 1),
    borderRadius: theme.shape.borderRadius,
    fontSize: '0.8125rem',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  stato: {
    fontWeight: 700,
  },
  scaduto: {
    backgroundColor: fade(theme.palette.error.main, 0.12),
    color: theme.palette.error.dark,
  },
  oggi: {
    backgroundColor: theme.palette.warning.dark,
    color: theme.palette.warning.contrastText,
  },
  entro15: {
    backgroundColor: theme.palette.warning.dark,
    color: theme.palette.warning.contrastText,
  },
  entro30: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
  },
  oltre30: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.primary,
  },
}));

/**
 * The expiry of a document as a pill toned by how close it is. `children` is the
 * date as the table writes it; with no readable expiry it is shown bare.
 */
export default function ScadenzaPill({ dataScadenza, children }) {
  const classes = useStyles();
  const giorni = giorniAllaScadenza(dataScadenza);
  const fascia = fasciaScadenza(giorni);
  if (!fascia) return <span>{children}</span>;

  const stato = statoScadenza(giorni);
  return (
    <span className={`${classes.pill} ${classes[fascia]}`}>
      <span>{children}</span>
      {stato && (
        <>
          <span aria-hidden="true">·</span>
          <span className={classes.stato}>{stato}</span>
        </>
      )}
    </span>
  );
}

ScadenzaPill.propTypes = {
  dataScadenza: PropTypes.string,
  children: PropTypes.node.isRequired,
};

ScadenzaPill.defaultProps = {
  dataScadenza: null,
};
